"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PrudencioProvider = void 0;

var _react = _interopRequireDefault(require("react"));

var _ = require(".");

var _theme = require("./theme");

var _GlobalStyles = require("./GlobalStyles");

var PrudencioProvider = function PrudencioProvider(_ref) {
  var _ref$theme = _ref.theme,
      theme = _ref$theme === void 0 ? _theme.theme : _ref$theme,
      children = _ref.children;
  return _react.default.createElement(_.ThemeProvider, {
    theme: theme,
    messages: ""
  }, _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_GlobalStyles.GlobalStyles, null), children));
};

exports.PrudencioProvider = PrudencioProvider;